<template>
    <header>
        <div class="flex justify-between items-center w-full mb-[20px]">
            <div class="block sm:hidden cursor-pointer" @click="$router.push('/forecast')">
                <img src="../../../public/icon/logo_mobile.png" />
            </div>
            <div class="hidden sm:block cursor-pointer" @click="$router.push('/forecast')">
                <img src="../../../public/icon/logo.png" />
            </div>
            <font-awesome-icon v-if="!!mainStore?.access_token_forecast" icon="fa-solid fa-arrow-right-from-bracket"
                title="Logout" class="cursor-pointer h-[30px]" @click="logout" />
        </div>
        <div v-if="!!mainStore?.access_token_forecast && $route?.path != '/forecast'"
            class="flex gap-[10px] items-center justify-around flex-wrap mt-[20px]">
            <div class="button p-[5px]" @click="$router.push('/forecast/scelta-veicolo')">Seleziona tipo veicolo</div>
        </div>
    </header>
</template>

<script>
import { mainStore } from '../../../store/main';
import axios from 'axios';

export default {
    name: 'HeaderView',
    data() {
        return {
            mainStore
        }
    },
    methods: {
        async logout() {
            const loader = this.$loading.show();

            try {
                await axios.post(`${process.env.VUE_APP_HOST}/auth/realms/${process.env.VUE_APP_REALM_FORECAST}/protocol/openid-connect/logout`, {
                    client_id: process.env.VUE_APP_CLIENT_ID_FORECAST,
                    refresh_token: this.mainStore.refresh_token_forecast
                }, { headers: { "content-type": "application/x-www-form-urlencoded" } });
            } catch (error) {
                console.log("error", error);
                this.$notify({
                    title: "Errore",
                    text: error?.response?.data?.error ? error.response.data.error : error?.response?.statusText,
                    type: "error",
                });
            }
            this.$cookies.remove("token_forecast");
            this.$cookies.remove("refreshToken_forecast");
            this.mainStore.access_token_forecast = null;
            this.mainStore.refresh_token_forecast = null;
            this.$router.push("/forecast");

            loader.hide();
        }
    }
}
</script>